import { render, staticRenderFns } from "./ApplicationFormPage.vue?vue&type=template&id=3fd5032c&scoped=true&"
import script from "./ApplicationFormPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationFormPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFormPage.vue?vue&type=style&index=0&id=3fd5032c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd5032c",
  null
  
)

export default component.exports